import workspaceQuery from '../../../graphql/queries/salesLedger/AutomatedCreditControlWorkflowWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/salesLedger/AutomatedCreditControlWorkflowListQuery.graphql';
import instanceQuery from '../../../graphql/queries/salesLedger/AutomatedCreditControlWorkflowQuery.graphql';
import defaultQuery from '../../../graphql/queries/salesLedger/AutomatedCreditControlWorkflowDefault.graphql';
import mutationQuery from '../../../graphql/mutations/salesLedger/AutomatedCreditControlWorkflowMutation.graphql';
import fragment from '../../../graphql/fragments/salesLedger/AutomatedCreditControlWorkflowFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { formActionsForPermissions } from '../../../actions/salesLedger/AutomatedCreditControlWorkflowAction';

const AutomatedCreditControlWorkflow: EntityType = {
  type: 'AutomatedCreditControlWorkflow',
  title: 'Automated Credit Control Workflow',
  formTitle: 'Automated Credit Control Workflow',
  formUrl: '/Customers/AutomatedCreditControlWorkflow/Details/',
  workspaceUrl: '/Customers/AutomatedCreditControlWorkflow/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'ACC_WORKFLOW',
  actions: formActionsForPermissions,
};

export default AutomatedCreditControlWorkflow;
